import { PlcConnectionMasterDto } from "src/dtos/plcTag/plcConnectionMasterDto";
import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { getData } from "../utils/axios/serverHelper";

/** PLC 공통 API 기본 경로 (백엔드 PlcConnectionMasterController) */
const baseUrl = `${config.apiUrl}/plc`;

/**
 * 사용 중인 PLC 전체 목록 조회 (GET /plc/list). 공통 Store fetchPlcCdCode에서 호출한다.
 * @returns 사용 중(use_yn = 'Y')인 PLC 목록 (사업장 구분 없이 전체)
 */
export const getPlcList = async () => {
	const url = `${baseUrl}/list`;
	return await getData<ResponseDto<PlcConnectionMasterDto[]>>(url);
};
